export default [
  {
    path: '/myTraining',
    name: 'myTraining',
    component: () => import('@/views/myTraining/index.vue'),
    meta: { title: 'app_my_training', hidden: true, pageLevel: 2 }
  },
  {
    path: '/trainingDetail',
    name: 'trainingDetail',
    component: () => import('@/views/myTraining/trainingDetail/index.vue'),
    meta: { title: 'pc_common_project_detail', hidden: true, customWechatShare: true }
  },
  {
    path: '/otherTraining',
    name: 'OtherTraining',
    component: () => import('@/views/myTraining/otherTraining/index.vue'),
    meta: { title: 'app_my_training_other', hidden: true }
  },
  {
    path: '/trainingHomework',
    name: 'TrainingHomework',
    component: () => import('@/views/myTraining/homework/index.vue'),
    meta: { title: 'app_homework_content', hidden: true }
  },
  {
    path: '/trainingSignSuccess',
    name: 'trainingSignSuccess',
    component: () => import('@/views/myTraining/sign/signSuccess.vue'),
    meta: { title: 'scan_signin', hidden: true }
  },
  {
    path: '/signTask',
    name: 'SignTask',
    component: () => import('@/views/myTraining/sign/signTask.vue'),
    meta: { title: 'scan_signin', hidden: true }
  },
  {
    path: '/linkTask',
    name: 'LinkTask',
    component: () => import('@/views/myTraining/linkTask/linkTask.vue'),
    meta: { title: 'tag_link', hidden: true }
  },
  {
    path: '/trainingLink',
    name: 'TrainingLink',
    component: () => import('@/views/myTraining/linkTask/Iink.vue'),
    meta: { title: 'tag_link', hidden: true }
  },
  {
    path: '/selfRegistrationDetail',
    name: 'SelfRegistrationDetail',
    component: () => import('@/views/myTraining/selfRegistration/detail.vue'),
    meta: { title: '', hidden: true }
  },
  {
    path: '/archivetrainingDetail',
    name: 'ArchivetrainingDetail',
    component: () => import('@/views/myTraining/archive/archivetrainingDetail.vue'),
    meta: { title: 'app_details', hidden: true, customWechatShare: true }
  }
]
